import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import Box from '@mui/material/Box';

export default function LottieAnimationWithLocalFile(props) {

    const container =useRef(null);

    useEffect(() => {
        props && lottie.loadAnimation({
            container: container.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: require(`${props.path}`)
        })
    }, [])

    return (

        <Box
            sx={{
                width: `${props.width}`,
                height: `${props.height}`
            }}
            ref={container}
        >
        </Box>

    )
}